import { Route, Routes as RouteContainer, Navigate } from 'react-router-dom';

import { WithGuard } from '@/guards';
import { AuthGuard } from '@/guards/auth.guard';
import { NonLoginGuard } from '@/guards/non-login.guard';

import { MasterLayout } from '@/layouts/master-layout';
import MainLayout from '@/layouts/main.layout';

import LoginPage from '@/pages/login.page';
import NotFoundPage from '@/pages/not-found.page';
import IndexPage from '@/pages/index.page';
import { withPrefix } from '@/utils/navigate';

// home
import BannerSlider from '@/modules/permissions/banner-slider.permission';
import BannerHeader from '@/modules/permissions/banner-header.permission';
import HomeAboutUs from '@/modules/home/about-us.home';

// users
import UserClientManagement from '@/modules/users/client-management.user';
import UserActivity from '@/modules/users/activity-log.user';
import UserAdminManagement from '@/modules/permissions/admin-management.permission';
import RoleManagement from '@/modules/permissions/role-management.permission';
import AdminActivityLog from '@/modules/permissions/admin-activity-log.permission';
import UnitConversionManagement from '@/modules/health/unit-conversion.health';

import ChatGPTManagement from '@/modules/permissions/chatGPT-management.permission';
import ConclusionRecommendationManagement from '@/modules/health/conclusion-recommendation.health';
import ManagementPhysicalActivity from '@/modules/permissions/manage-physical-activity.permission';
import Page403 from '@/pages/403.page';

import FoodManagement from '@/modules/permissions/food-management.permission';
import DishManagement from '@/modules/permissions/dish-management.permission';
import HealthStatusManagement from '@/modules/health-consulting-management/health-status-management';
import ProductManagement from '@/modules/permissions/product-management.permission';
import NutritionStandardsManagement from '@/modules/permissions/nutrition-standards-management.permission';
import AdviceRecommend from '@/modules/advice-recommend/advice-recommend.home';
import ComboFoodManagement from '@/modules/permissions/combo-food-management.permission';
import NutritionalMenuCalculatorManagement from '@/modules/permissions/nutritional-menu-calculator.permission';
import HistoryChatBotPermission from '@/modules/permissions/history-chatbot.permission';
import UploadKeyTokenPermission from '@/modules/permissions/upload-key-token.permission';
import NotificationManagementPermission from '@/modules/permissions/notification-management.permission';
import StatisticsProfilesPage from '@/modules/statistics/profiles';

export default function Routes() {
  return (
    <RouteContainer>
      <Route path={withPrefix('')} Component={MasterLayout}>
        <Route
          path={withPrefix('')}
          element={<WithGuard Page={IndexPage} Guard={AuthGuard} />}
        />
        <Route
          path='login'
          element={<WithGuard Page={LoginPage} Guard={NonLoginGuard} />}
        />
        <Route path='404' Component={NotFoundPage} />
      </Route>
      <Route path={withPrefix('')} Component={MainLayout}>
        <Route
          path={withPrefix('statistics')}
          element={<WithGuard Page={StatisticsProfilesPage} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('users/management')}
          element={<WithGuard Page={UserClientManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('users/activity-log')}
          element={<WithGuard Page={UserActivity} Guard={AuthGuard} />}
        />

        <Route
          path={withPrefix('home/banner-slider')}
          element={<WithGuard Page={BannerSlider} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('home/about-us')}
          element={<WithGuard Page={HomeAboutUs} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('home/banner-header')}
          element={<WithGuard Page={BannerHeader} Guard={AuthGuard} />}
        />
      </Route>
      <Route path={withPrefix('')} Component={MainLayout}>
        <Route
          path={withPrefix('permissions/admin-management')}
          element={<WithGuard Page={UserAdminManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('permissions/role-management')}
          element={<WithGuard Page={RoleManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('permissions/admin-activity-log')}
          element={<WithGuard Page={AdminActivityLog} Guard={AuthGuard} />}
        />
      </Route>
      <Route path={withPrefix('')} Component={MainLayout}>
        <Route
          path={withPrefix('/health/unit-conversion')}
          element={
            <WithGuard Page={UnitConversionManagement} Guard={AuthGuard} />
          }
        />
        <Route
          path={withPrefix('/health/conclusion-recommendation')}
          element={
            <WithGuard
              Page={ConclusionRecommendationManagement}
              Guard={AuthGuard}
            />
          }
        />
      </Route>
      <Route path={withPrefix('')} Component={MainLayout}>
        <Route
          path={withPrefix('/wellnessCare/manage-physical-activity')}
          element={
            <WithGuard Page={ManagementPhysicalActivity} Guard={AuthGuard} />
          }
        />
        <Route
          path={withPrefix('/wellnessCare/food-management')}
          element={<WithGuard Page={FoodManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('/wellnessCare/dish-management')}
          element={<WithGuard Page={DishManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('/wellnessCare/health-status-management')}
          element={
            <WithGuard Page={HealthStatusManagement} Guard={AuthGuard} />
          }
        />
        <Route
          path={withPrefix('/wellnessCare/product-management')}
          element={<WithGuard Page={ProductManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('/wellnessCare/nutrition-standards-management')}
          element={
            <WithGuard Page={NutritionStandardsManagement} Guard={AuthGuard} />
          }
        />
        <Route
          path={withPrefix('/wellnessCare/advice-recommendation-management')}
          element={<WithGuard Page={AdviceRecommend} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('/wellnessCare/combo-food-management')}
          element={<WithGuard Page={ComboFoodManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix(
            '/wellnessCare/nutritional-menu-calculator-management'
          )}
          element={
            <WithGuard
              Page={NutritionalMenuCalculatorManagement}
              Guard={AuthGuard}
            />
          }
        />
      </Route>{' '}
      <Route path={withPrefix('')} Component={MainLayout}>
        <Route
          path={withPrefix('/notification-management')}
          element={
            <WithGuard
              Page={NotificationManagementPermission}
              Guard={AuthGuard}
            />
          }
        />
      </Route>
      <Route path={withPrefix('')} Component={MainLayout}>
        <Route
          path={withPrefix('/gpt/chatGPT-management')}
          element={<WithGuard Page={ChatGPTManagement} Guard={AuthGuard} />}
        />
        <Route
          path={withPrefix('/gpt/history-chat-box')}
          element={<WithGuard Page={HistoryChatBotPermission} Guard={AuthGuard} />}
        />
           <Route
          path={withPrefix('/gpt/upload-key-and-config')}
          element={<WithGuard Page={UploadKeyTokenPermission} Guard={AuthGuard} />}
        />
        
      </Route>
      <Route path='/403' element={<Page403 />} />
      <Route path='*' element={<Navigate to={withPrefix('/404')} replace />} />
    </RouteContainer>
  );
}
